// extracted by mini-css-extract-plugin
module.exports =  {"chip":"tFM0usz9zstjzRJ38sAR"};